// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fb7392e3","732":"f4f01d55"}[chunkId] + ".chunk.js";
};